require("!!D:\\Aliva\\IPCL\\IPCL_SELF_CARE\\node_modules\\script-loader\\addScript.js")(require("!!D:\\Aliva\\IPCL\\IPCL_SELF_CARE\\node_modules\\raw-loader\\index.js!D:\\Aliva\\IPCL\\IPCL_SELF_CARE\\node_modules\\jquery\\dist\\jquery-3.7.1.min.js"))


//////////////////
// WEBPACK FOOTER
// D:/Aliva/IPCL/IPCL_SELF_CARE/~/script-loader!D:/Aliva/IPCL/IPCL_SELF_CARE/~/jquery/dist/jquery-3.7.1.min.js
// module id = ../../../../script-loader/index.js!../../../../jquery/dist/jquery-3.7.1.min.js
// module chunks = 3